import { render, staticRenderFns } from "./AffiliateDashboard.vue?vue&type=template&id=3c8997d4&scoped=true&"
import script from "./AffiliateDashboard.vue?vue&type=script&lang=js&"
export * from "./AffiliateDashboard.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateDashboard.vue?vue&type=style&index=0&id=3c8997d4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8997d4",
  null
  
)

export default component.exports